module.exports = __webpack_public_path__ + "static/media/tilephoto2.05b673d2.png";